export enum AdjustmentWarningType {
    PRE_EXISTENCE = 'pre_existence',
    DUPLICATED_INVOICE = 'duplicated_invoice',
    WAITING_PERIOD = 'waiting_period',
}
